import { REDUCER_MANAGEMENT_GET_DATA, REDUCER_MANAGEMENT_CLEAR } from "../../../../../constants/reducers/management-get-data";
import { REDUCER_SET_META_DATA, REDUCER_CHECKPOINT } from '../../../../../constants/reducers/get-meta-data'
import adjustPages from '../../../../../helpers/merge-page-info'

const DEFAULT_STATE = {}

export default (state = DEFAULT_STATE, action) => {
  const {type} = action

  switch (type) {
    case REDUCER_MANAGEMENT_GET_DATA:
      return action.payload;
    case REDUCER_MANAGEMENT_CLEAR:
      return DEFAULT_STATE;
    case REDUCER_CHECKPOINT:
      return 'payload' in action &&
              action.payload &&
              'checkpoint' in action.payload &&
              action.payload.checkpoint &&
              'Management' in action.payload.checkpoint &&
              action.payload.checkpoint.Management ?
                action.payload.checkpoint.Management
              :
                DEFAULT_STATE
    case REDUCER_SET_META_DATA:
      return 'payload' in action &&
              action.payload &&
              'management' in action.payload &&
              action.payload.management ?
                adjustPages(action.payload.management.pages, action.payload.management.filters, action.payload.management.decorators)
              :
                DEFAULT_STATE
    default:
      return state;
  }
}
